import React, { useState, useEffect } from 'react';
import '../Sidebar.css';
import '../Buttons.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import api from '../../api';

const SUPSidebarRight = ({
    currentSupplier,
    plants = [],
    supplierPlantData = [],
    isLoggedIn,
    onSelectCrop,
    selectedCrop,
    handleAddPlant,
    handleRemovePlant,
    handleTabChange
}) => {
    const [showCropSelect, setShowCropSelect] = useState(false);
    const [expandedCropId, setExpandedCropId] = useState(null);
    const [allPlants, setAllPlants] = useState([]);


    const toggleCrop = (cropId) => {
        if (currentSupplier?.isNewSupplier) return;
        console.log('selectedcrop: ', selectedCrop, 'crop passed in: ', cropId)
        const isExpanded = selectedCrop === cropId;

        if (isExpanded) {
            // collapse crop + close form
            setExpandedCropId(null);
            onSelectCrop(null);
        } else {
            // expand new crop, but keep form closed until variety/add is chosen
            setExpandedCropId(cropId);
            onSelectCrop(cropId);
            handleTabChange('Home');
        }
    };

    useEffect(() => {
        const fetchAllPlants = async () => {
            try {
                const response = await api.get('/plants/all');

                // Optional: Validate content type if needed
                const contentType = response.headers['content-type'];
                if (!contentType || !contentType.includes('application/json')) {
                    throw new TypeError(`Expected JSON response, but received: ${contentType}`);
                }

                const data = response.data;
                setAllPlants(data);
            } catch (err) {
                console.error('Error fetching all plants:', err);
            }
        };

        fetchAllPlants();
    }, []);

    const supplierCropIDs = plants.map(p => p.id);
    const availablePlants = allPlants.filter(p => !supplierCropIDs.includes(p.plantID));
    

    return (
        <div className="sidebar-right">
            {!isLoggedIn || !currentSupplier ? (
                <div>
                    <h2>HOW DO I START</h2>
                    <p>1. Click Get Started to tell us what you eat and where you grow.</p>
                    <p>2. We will match you with plants that thrive in your location.</p>
                    <p>3. You will get a seasonal planting calendar and seasonal gardening tasks.</p>
                    <h4>Sit back and let the app guide your gardening journey!</h4>
                </div>
            ) : (
                <div className="current-gardener">
                    {/* Supplier Info */}
                    <h2>Profile</h2>
                    <div className="gardener-info">
                        <div className="gardener-row">
                            <span className="gardener-label">Name:</span>
                            <span className="gardener-value">{currentSupplier.name || ''}</span>
                        </div>
                            <div className="gardener-row">
                                <span className="gardener-label">eMail:</span>
                                <span className="gardener-value">{currentSupplier.email || ''}</span>
                            </div>
                            <div className="gardener-row">
                                <span className="gardener-label">Phone:</span>
                                <span className="gardener-value">{currentSupplier.phone || ''}</span>
                            </div>
                            <div className="gardener-row">
                                <span className="gardener-label">Street Address:</span>
                                <span className="gardener-value">{currentSupplier.streetAddress || ''}</span>
                            </div>
                            <div className="gardener-row">
                                <span className="gardener-label">City:</span>
                                <span className="gardener-value">{currentSupplier.city || ''}</span>
                            </div>
                        <div className="gardener-row">
                            <span className="gardener-label">Province:</span>
                            <span className="gardener-value">{currentSupplier.province || ''}</span>
                        </div>
                        <div className="gardener-row">
                            <span className="gardener-label">Country:</span>
                            <span className="gardener-value">{currentSupplier.country || ''}</span>
                        </div>
                    </div>
                    <div className="section-spacer" />
                    {/* Crop Tabs */}
                    <h2>Current Crops</h2>

                    {/* Add Crop Tab */}
                    <div
                        className={`crop-tab add-crop`}
                        onClick={() => {

                            // 1) Open the crop selector
                            setShowCropSelect(prev => !prev);

                            // 2) Immediately switch to Home tab
                            handleTabChange('Home');
                        }}
                    >
                        <FontAwesomeIcon icon={faPlus} className="plus-icon" />
                        <span>Add Crop</span>
                    </div>
                    {showCropSelect && (
                        <div className="crop-selector">
                            <label htmlFor="plant">Select a new crop to add:</label>
                            <select
                                name="plantID"
                                id="plant"
                                onChange={(e) => {
                                    const selectedID = parseInt(e.target.value);
                                    const selectedPlant = availablePlants.find(p => p.plantID === selectedID);
                                    if (selectedPlant) {
                                        handleAddPlant({ plantID: selectedPlant.plantID }); //  add immediately
                                        toggleCrop(selectedPlant.plantID)
                                        setShowCropSelect(false);                      // close dropdown
                                    }
                                }}
                            >
                                <option value="">-- Choose a new crop --</option>
                                {availablePlants.map((plant) => (
                                    <option key={plant.plantID} value={plant.plantID}>
                                        {plant.name}
                                    </option>
                                ))}
                            </select>
                        </div>
                    )}

                    <div className="crop-tabs">
                        {plants.map((plant) => {
                            const varieties = supplierPlantData.filter((data) => data.plantID === plant.id);
                            const isExpanded = selectedCrop === plant.id;

                            return (
                                <div key={plant.id} className="crop-tab">
                                    <div
                                        className="crop-tab-header"
                                        onClick={() => toggleCrop(plant.id)}
                                    >
                                        <strong>
                                            {plant.name} 
                                        </strong>
                                    </div>

                                    {isExpanded && (
                                        <div className="variety-tab-list">
                                            <button
                                                className="remove-crop-button"
                                                onClick={() => { handleRemovePlant(plant.id) }}
                                            >
                                                Remove Crop
                                            </button>
                                        </div>
                                    )}
                                </div>
                            );
                        })}
                    </div>
                </div>
            )}
        </div>
    );
};

export default React.memo(SUPSidebarRight);
